import { Badge } from '@mantine/core';
import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react';
import type { FC } from 'react';

import styles from './VerificationBadge.module.css';

interface VerificationBadgeProps {
  isCorrect: boolean;
  text: string;
}

export const VerificationBadge: FC<VerificationBadgeProps> = ({ isCorrect, text }) => (
  <Badge
    classNames={styles}
    color={isCorrect ? 'green' : 'red'}
    leftSection={isCorrect ? <CheckCircleIcon size="14" /> : <XCircleIcon size="14" />}
    size="lg"
    variant="light"
  >
    {text}
  </Badge>
);
